.kbd {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 20px; height: 20px; padding: 0 var(--space-1-5);
  border: 1px solid var(--color-border-strong); border-bottom-width: 2px; border-radius: var(--radius-xs);
  background: var(--color-surface-sunken); color: var(--color-text-secondary);
  font-family: var(--font-ui); font-size: var(--text-2xs); font-weight: var(--weight-medium);
  font-variant-numeric: tabular-nums; line-height: 1;
}
